module.exports = __webpack_public_path__ + "media/images/home/logo_cemaden-fdd8216b831ac6c5f2240845aaa72744.png";